import { User } from '../../_models';
import { BreadcrumbService } from './../../_services/breadcrumb.service';
import { Component, OnInit, } from '@angular/core';
import { AuthenticationService, MenuService } from '../../_services';


@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
   user: User | undefined;

  constructor(
    private breadServ: BreadcrumbService,
    private menuServ: MenuService,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    const user = this.authService.currentUserValue;
    this.user = user;
    this.breadServ.setCurrent({
      header: 'Página não encontrada',
      description: 'Você está tentando acessar uma página inexistente',
      display: true,
      levels: [
        {
          icon: 'dashboard',
          link: ['/'],
          title: 'Home'
        }
      ]
    });
  }
}
